import '../../../UI Design/Services.css';
import { useNavigate } from 'react-router-dom';


export default function Services() {
    const navigate = useNavigate();

    const handleNavigate = (service) => {
        navigate('/services_details', { state: { service } });
    };

    return (
        <div class="services" id="services">
            <h2 className="heading">My <span>Services</span></h2>
            <div className="services-container">
                <div className="services-box">
                    <i className='bx bx-code-alt'></i>
                    <h3>Website Development</h3>
                    <p>Our web development services are designed to create dynamic, responsive, and user-friendly websites. We leverage the latest technologies to build custom solutions that meet your unique business needs. Whether it's a simple website or a complex web application, we ensure it performs seamlessly across all devices and platforms.</p>
                    <button className='btn' onClick={() => handleNavigate('website')}>Read More</button>
                </div>

                <div className="services-box">
                    <div className='two-icons'>
                        <i class='bx bxl-android'></i>
                        <h1>/</h1>
                        <i class='bx bxl-apple' ></i>
                    </div>
                    <h3>Mobile App Development</h3>
                    <p>Our mobile app development services cover both Android and iOS platforms, delivering high-performance and feature-rich applications. From conceptualization to deployment, we handle every aspect of the app development process to ensure a smooth user experience and optimal functionality. Let us help you transform your ideas into reality.</p>
                    <button className='btn' onClick={() => handleNavigate('mobile_app')}>Read More</button>
                </div>

                <div className="services-box">
                    <i class='bx bx-id-card'></i>
                    <h3>Portfolio Design</h3>
                    <p>Your portfolio is a reflection of your professional identity. Our portfolio design services are tailored to showcase your skills, achievements, and projects in the best light. We create visually appealing and organized portfolios that capture the essence of your work, helping you stand out in your industry. Trust us to design a portfolio that leaves a lasting impression.</p>
                    <button className='btn' onClick={() => handleNavigate('portfolio')}>Read More</button>
                </div>
            </div>
        </div>
    )
}